import React from "react";
import { Button } from "@material-ui/core";
import clsx from "clsx";
import { useStyles } from "./ReportQueueManagementTable.styles";
import { REPORT_QUEUE_STATUS_CODES } from "../../../constants";
const ActionCell = ({ statusId, onCancel, onView, isCancelling=false }) => {
  const classes = useStyles();

  return (
    <td data-column="Action" className={clsx([classes.centerAlign, classes.columnBorder])}>
      {statusId === null && (
        <Button
          variant="contained"
          color="secondary"
          size="small"
          onClick={onCancel}
          disabled={isCancelling}
        >
          Cancel
        </Button>
      )}

      {statusId === REPORT_QUEUE_STATUS_CODES.COMPLETED && (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={onView}
        >
          View
        </Button>
      )}

      {
        (statusId === REPORT_QUEUE_STATUS_CODES.PROCESSING || 
        statusId === REPORT_QUEUE_STATUS_CODES.ABANDONED || 
        statusId === REPORT_QUEUE_STATUS_CODES.CANCELED_BY_CUSTOMER ||
        statusId === REPORT_QUEUE_STATUS_CODES.CANCELED_BY_ADMIN)  && 
        <span className={classes.naText}>N/A</span>
      }

      {
        statusId === REPORT_QUEUE_STATUS_CODES.REPORT_SERVICE_ERROR && (
          <span>Failed to create a report</span>
        )
      }

      {
        statusId === REPORT_QUEUE_STATUS_CODES.UNKNOWN_ERROR && (
          <span>Error details not available</span>
        )
      }

      {
        statusId === REPORT_QUEUE_STATUS_CODES.FAILED_TO_SAVE && (
          <span>Failed to save a report</span>
        )
      }
    </td>
  );
}

export default ActionCell;
